import { z } from 'zod';
import { MediaDTO } from '../../../client';
import { PriceDTO } from '../types';
import { ProductDetailPromotionDTO } from './ProductDetailPromotionDTO';

export const ProductDetailVariantDTO = z
    .object({
        id: z.string(),
        url: z.string().nullish(),
        name: z.string().nullish(),
        swatchImageUrl: z.string().nullish(),
        imageUrl: z.string().nullish(),
        isAvailable: z.boolean().nullish(),
        format: z.string().nullish(),
        promotion: ProductDetailPromotionDTO,
        medias: z.array(MediaDTO).default([]),
        pricePerUnit: z.string().nullish(),
    })
    .and(PriceDTO);

export type ProductDetailVariantDTO = z.infer<typeof ProductDetailVariantDTO>;
